export default {
  name: "PortalError",
  methods: {
    reloadPage: function reloadPage() {
      window.location.reload();
    }
  }
};